import React, { useState } from 'react';
import { Box, Button, ButtonProps, Link, Text } from '@99designs/emu';
import { IconDownload1 } from '@99designs/icons';
import FileDownloadExtensionValidationModal from './FileDownloadExtensionValidationModal';
import allowedFileExtensions from './allowedFileExtensions';

interface FileDownloadButtonProps {
    extension: string;
    downloadUrl: string;
    disabled?: boolean;
    isLink?: boolean;
    onClick?: () => void;
    size?: ButtonProps['size'];
}

function FileDownloadButton({
    extension,
    downloadUrl,
    disabled,
    onClick,
    isLink,
    size,
}: FileDownloadButtonProps) {
    const [isFileDownloadValidationActive, setIsFileDownloadValidationActive] = useState(false);
    const download = () => {
        window.location.assign(downloadUrl);
        setIsFileDownloadValidationActive(false);
    };
    const cancel = () => setIsFileDownloadValidationActive(false);

    function goToDownload() {
        const isFileExtensionValid = allowedFileExtensions.indexOf(extension) !== -1;

        if (isFileExtensionValid) {
            download();
            onClick?.();
        } else {
            setIsFileDownloadValidationActive(true);
        }
    }

    return (
        <>
            {isLink ? (
                <Link underline="none" onClick={goToDownload}>
                    <Box as="span" marginRight="0.25bu">
                        <IconDownload1 />
                    </Box>
                    <Text weight="bold">{__('Download')}</Text>
                </Link>
            ) : (
                <Button
                    appearance="secondary"
                    icon={IconDownload1}
                    onClick={goToDownload}
                    disabled={disabled}
                    type="submit"
                    width="fill"
                    size={size || 'medium'}
                >
                    {__('Download')}
                </Button>
            )}

            {isFileDownloadValidationActive && (
                <FileDownloadExtensionValidationModal onConfirm={download} onClose={cancel} />
            )}
        </>
    );
}

export default FileDownloadButton;
